@settingsWidth: 850px;

.content {
  max-width: @settingsWidth;
}

.top-content {
  display: flex;
  flex-direction: column;
}

.primary-action {
  width: 100%;
  display: flex;
  margin-bottom: 10px;
  justify-content: flex-end;
}

.create-icon {
  width: 10px;
  height: 10px;
  margin-right: 5px;
}
